import { MiBuildHouseAlt } from "@miplatform/assets";
import {
  MiDetailFields,
  MiIcon,
  MiPlaceholderArea,
  MiSectionHeader,
} from "@miplatform/components";
import { INPUT_TYPES } from "@miplatform/constants";
import { mdiMagnify } from "@mdi/js";
import { useTheme } from "@mui/material";

export function CopyExistingPlans({ open }: CopyExistingPlansProps) {
  const theme = useTheme();

  if (!open) {
    return null;
  }

  const filterFields = [
    {
      placeholder: "Search for Plan Template",
      textfieldProps: {
        startAdornment: (
          <MiIcon path={mdiMagnify} color={theme.palette.grey.medium} />
        ),
      },
    },
    {
      label: "Series",
      fieldType: INPUT_TYPES.SELECT,
    },
    {
      label: "Community",
      fieldType: INPUT_TYPES.SELECT,
    } as any,
  ];

  return (
    <>
      <MiSectionHeader
        variant="text"
        title="Select Plan Template"
        subtitle="Select from the list of area templates"
      />
      <MiDetailFields detailFields={filterFields} />
      <MiPlaceholderArea
        text="No Plans to Display"
        helperText="Approved plans will show up here."
        iconComponent={<img src={MiBuildHouseAlt} alt="House Icon" />}
        containerStyle={{
          backgroundColor: theme.palette.primary.light,
          margin: theme.spacing(1),
        }}
      />
    </>
  );
}

interface CopyExistingPlansProps {
  open: boolean;
}
